import controller from './pendientes-items.controller';

import templateBase from './templates/pendientes-items.view.html';
import adaptativo from './templates/pendientes-items-adaptativo.view.html';

let ReportPendientesItemsComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
  if(__env.adaptative){
    return adaptativo;
  } else {
    return templateBase;
  }
}


export default ReportPendientesItemsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/reports/pendientesItems/pendientes-items.component.js
 **/